import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  const accessCodes = [
    'tVO0oWh5oX', // Primary code
    'Gospel2025',
    'WisePublish1',
    'ChristCentered2',
    'Faithful3Author',
    'Kingdom4Books',
    'Grace5Writer',
    'Mission6Publish'
  ];

  useEffect(() => {
    const authStatus = localStorage.getItem('gospelwise-auth');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    } else {
      setShowAuthModal(true);
    }
  }, []);

  const authenticate = (code) => {
    if (accessCodes.includes(code)) {
      setIsAuthenticated(true);
      setShowAuthModal(false);
      localStorage.setItem('gospelwise-auth', 'true');
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    setShowAuthModal(true);
    localStorage.removeItem('gospelwise-auth');
  };

  const value = {
    isAuthenticated,
    showAuthModal,
    authenticate,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};